export default "__VITE_ASSET__BAgyoETN__"